"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAdminAccess = void 0;
/**
 * use this for access controls for backend and frontend
 */
var hasAdminAccess = function (accountType) {
    var roles = ['admin', 'superadmin'];
    return roles.includes(accountType);
};
exports.hasAdminAccess = hasAdminAccess;
//# sourceMappingURL=Authorization.js.map